export default __webpack_public_path__ + "static/media/logoFARMEX.6c5e4081.png";